import { render, staticRenderFns } from "./ParticipantsPromotionChart.vue?vue&type=template&id=3074e830&scoped=true"
import script from "./ParticipantsPromotionChart.vue?vue&type=script&lang=js"
export * from "./ParticipantsPromotionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3074e830",
  null
  
)

export default component.exports